import React from 'react';

import Styles from './hr.module.scss';

const Hr = () => {
  return <hr className={Styles['hr']} />;
};

export default Hr;
